import React from "react";

import Text from "./parts/Text";
import Title from "./parts/Title";
import List from "./parts/List";
import BulletList from "./parts/BulletList";

const RenderPart = ({ item }) => {

	switch (item.type) {
		case "text":
			return <Text value={item.value} />;

		case "title":
			return <Title value={item.value} />;

		case "list":
			return <List items={item.values} />;

		case "bullet-list":
			return <BulletList items={item.values} />;

		default:
			return null;
	}
};

export default RenderPart;
